"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require("lru-memoize");

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require("../../utils/validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var companyInfoValidation = (0, _validation.createValidator)({
  address: _validation.required,
  postal_code: _validation.required,
  postal_area: _validation.required,
  business_id: [_validation.required, _validation.businessId],
  company_name: _validation.required
});
exports.default = (0, _lruMemoize2.default)(10)(companyInfoValidation);
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Company/companyInfoValidator.js
 ** module id = 1210
 ** module chunks = 0
 **/